import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Box } from "../../Box/index.js";
import { Icon } from "../../Icon/index.js";
import { Button } from "../../Button/index.js";
import { ButtonGroup } from "../../ButtonGroup/index.js";
import { Portal } from "../../Portal/index.js";
import { useStyles } from "./PreviewButtons.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function PreviewButtons_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else PreviewButtons_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const PreviewButtons = (t0)=>{
    const $ = c(132);
    const { handleNextPage, pagesCount, nextPageNumber, pageNumber, scale, zoomLevels, handleZoom, onClose, withBottomOffset } = t0;
    const { classes } = useStyles();
    let T0;
    let T1;
    let T2;
    let getIconColor;
    let t1;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let zoomIn;
    if ($[0] !== classes.bottomOffset || $[1] !== classes.buttonGroup || $[2] !== classes.hiddenGroup || $[3] !== classes.input || $[4] !== classes.inputRoot || $[5] !== classes.option || $[6] !== classes.paper || $[7] !== classes.popper || $[8] !== classes.root || $[9] !== classes.rootBox || $[10] !== handleNextPage || $[11] !== handleZoom || $[12] !== nextPageNumber || $[13] !== pageNumber || $[14] !== pagesCount || $[15] !== scale || $[16] !== withBottomOffset || $[17] !== zoomLevels) {
        const options = zoomLevels.map(_temp);
        let t19;
        if ($[41] !== handleZoom || $[42] !== scale || $[43] !== zoomLevels) {
            t19 = ()=>{
                const nextZoom = zoomLevels.find((level)=>level > scale);
                if (nextZoom) handleZoom(nextZoom);
            };
            $[41] = handleZoom;
            $[42] = scale;
            $[43] = zoomLevels;
            $[44] = t19;
        } else t19 = $[44];
        zoomIn = t19;
        let t20;
        if ($[45] !== handleZoom || $[46] !== scale || $[47] !== zoomLevels) {
            t20 = ()=>{
                const prevZoom = [
                    ...zoomLevels
                ].reverse().find((level_0)=>level_0 < scale);
                if (prevZoom) handleZoom(prevZoom);
            };
            $[45] = handleZoom;
            $[46] = scale;
            $[47] = zoomLevels;
            $[48] = t20;
        } else t20 = $[48];
        const zoomOut = t20;
        let t21;
        if ($[49] !== handleNextPage) {
            t21 = (event)=>{
                event.preventDefault();
                event.stopPropagation();
                handleNextPage(_temp2);
            };
            $[49] = handleNextPage;
            $[50] = t21;
        } else t21 = $[50];
        const handlePrev = t21;
        let t22;
        if ($[51] !== handleNextPage || $[52] !== pagesCount) {
            t22 = (event_0)=>{
                event_0.preventDefault();
                event_0.stopPropagation();
                handleNextPage((x_0)=>Math.min(null != pagesCount ? pagesCount : 0, x_0 + 1));
            };
            $[51] = handleNextPage;
            $[52] = pagesCount;
            $[53] = t22;
        } else t22 = $[53];
        const handleNext = t22;
        getIconColor = _temp3;
        T2 = Portal;
        if ($[54] !== classes.bottomOffset || $[55] !== classes.buttonGroup || $[56] !== withBottomOffset) {
            t17 = classnames(classes.buttonGroup, {
                [classes.bottomOffset]: withBottomOffset
            });
            $[54] = classes.bottomOffset;
            $[55] = classes.buttonGroup;
            $[56] = withBottomOffset;
            $[57] = t17;
        } else t17 = $[57];
        t18 = "preview-buttons";
        T1 = ButtonGroup;
        t8 = "horizontal";
        t9 = "contained";
        t10 = "small";
        t11 = _temp4;
        const t23 = pagesCount <= 1;
        if ($[58] !== classes.hiddenGroup || $[59] !== classes.rootBox || $[60] !== t23) {
            t12 = classnames(classes.rootBox, {
                [classes.hiddenGroup]: t23
            });
            $[58] = classes.hiddenGroup;
            $[59] = classes.rootBox;
            $[60] = t23;
            $[61] = t12;
        } else t12 = $[61];
        const t24 = getIconColor(nextPageNumber <= 1);
        let t25;
        if ($[62] !== t24) {
            t25 = /*#__PURE__*/ jsx(Icon, {
                name: "arrow_left_outline",
                size: "16",
                color: t24
            });
            $[62] = t24;
            $[63] = t25;
        } else t25 = $[63];
        if ($[64] !== handlePrev || $[65] !== t25) {
            t13 = /*#__PURE__*/ jsx(Button, {
                onClick: handlePrev,
                icon: t25
            });
            $[64] = handlePrev;
            $[65] = t25;
            $[66] = t13;
        } else t13 = $[66];
        if ($[67] !== pageNumber || $[68] !== pagesCount) {
            t14 = /*#__PURE__*/ jsx(Button, {
                disabled: true,
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: 18,
                    children: [
                        pageNumber,
                        "/",
                        pagesCount
                    ]
                })
            });
            $[67] = pageNumber;
            $[68] = pagesCount;
            $[69] = t14;
        } else t14 = $[69];
        const t26 = getIconColor(nextPageNumber >= pagesCount);
        let t27;
        if ($[70] !== t26) {
            t27 = /*#__PURE__*/ jsx(Icon, {
                name: "arrow_right_outline",
                size: "16",
                color: t26
            });
            $[70] = t26;
            $[71] = t27;
        } else t27 = $[71];
        if ($[72] !== handleNext || $[73] !== t27) {
            t15 = /*#__PURE__*/ jsx(Button, {
                onClick: handleNext,
                icon: t27
            });
            $[72] = handleNext;
            $[73] = t27;
            $[74] = t15;
        } else t15 = $[74];
        const t28 = getIconColor(scale === zoomLevels[0]);
        let t29;
        if ($[75] !== t28) {
            t29 = /*#__PURE__*/ jsx(Icon, {
                name: "magnifier_minus_outline",
                size: "20",
                color: t28
            });
            $[75] = t28;
            $[76] = t29;
        } else t29 = $[76];
        if ($[77] !== t29 || $[78] !== zoomOut) {
            t16 = /*#__PURE__*/ jsx(Button, {
                icon: t29,
                onClick: zoomOut
            });
            $[77] = t29;
            $[78] = zoomOut;
            $[79] = t16;
        } else t16 = $[79];
        T0 = Autocomplete;
        t1 = options;
        t2 = true;
        t3 = _temp5;
        if ($[80] !== classes.input || $[81] !== classes.option || $[82] !== classes.paper || $[83] !== classes.popper || $[84] !== classes.root) {
            t4 = {
                root: classes.root,
                option: classes.option,
                inputRoot: classes.input,
                popper: classes.popper,
                paper: classes.paper
            };
            $[80] = classes.input;
            $[81] = classes.option;
            $[82] = classes.paper;
            $[83] = classes.popper;
            $[84] = classes.root;
            $[85] = t4;
        } else t4 = $[85];
        if ($[86] !== classes.inputRoot) {
            t5 = (params)=>/*#__PURE__*/ jsx(TextField, _object_spread_props(_object_spread({}, params), {
                    InputProps: _object_spread_props(_object_spread({}, params.InputProps), {
                        classes: {
                            root: classes.inputRoot
                        }
                    }),
                    sx: {
                        "& .MuiInput-underline:before": {
                            borderBottom: "none"
                        },
                        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                            borderBottom: "none"
                        }
                    }
                }));
            $[86] = classes.inputRoot;
            $[87] = t5;
        } else t5 = $[87];
        if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = /*#__PURE__*/ jsx(Icon, {
                name: "dropdown_outline",
                color: "original.brand.secondary",
                size: "12"
            });
            $[88] = t6;
        } else t6 = $[88];
        let t30;
        if ($[89] !== scale) {
            t30 = (option_0)=>option_0.value === scale;
            $[89] = scale;
            $[90] = t30;
        } else t30 = $[90];
        t7 = options.find(t30);
        $[0] = classes.bottomOffset;
        $[1] = classes.buttonGroup;
        $[2] = classes.hiddenGroup;
        $[3] = classes.input;
        $[4] = classes.inputRoot;
        $[5] = classes.option;
        $[6] = classes.paper;
        $[7] = classes.popper;
        $[8] = classes.root;
        $[9] = classes.rootBox;
        $[10] = handleNextPage;
        $[11] = handleZoom;
        $[12] = nextPageNumber;
        $[13] = pageNumber;
        $[14] = pagesCount;
        $[15] = scale;
        $[16] = withBottomOffset;
        $[17] = zoomLevels;
        $[18] = T0;
        $[19] = T1;
        $[20] = T2;
        $[21] = getIconColor;
        $[22] = t1;
        $[23] = t10;
        $[24] = t11;
        $[25] = t12;
        $[26] = t13;
        $[27] = t14;
        $[28] = t15;
        $[29] = t16;
        $[30] = t17;
        $[31] = t18;
        $[32] = t2;
        $[33] = t3;
        $[34] = t4;
        $[35] = t5;
        $[36] = t6;
        $[37] = t7;
        $[38] = t8;
        $[39] = t9;
        $[40] = zoomIn;
    } else {
        T0 = $[18];
        T1 = $[19];
        T2 = $[20];
        getIconColor = $[21];
        t1 = $[22];
        t10 = $[23];
        t11 = $[24];
        t12 = $[25];
        t13 = $[26];
        t14 = $[27];
        t15 = $[28];
        t16 = $[29];
        t17 = $[30];
        t18 = $[31];
        t2 = $[32];
        t3 = $[33];
        t4 = $[34];
        t5 = $[35];
        t6 = $[36];
        t7 = $[37];
        t8 = $[38];
        t9 = $[39];
        zoomIn = $[40];
    }
    let t19;
    if ($[91] !== handleZoom) {
        t19 = (_, newValue)=>handleZoom(newValue.value);
        $[91] = handleZoom;
        $[92] = t19;
    } else t19 = $[92];
    let t20;
    if ($[93] !== T0 || $[94] !== t1 || $[95] !== t19 || $[96] !== t2 || $[97] !== t3 || $[98] !== t4 || $[99] !== t5 || $[100] !== t6 || $[101] !== t7) {
        t20 = /*#__PURE__*/ jsx(T0, {
            options: t1,
            disableClearable: t2,
            getOptionLabel: t3,
            classes: t4,
            renderInput: t5,
            popupIcon: t6,
            value: t7,
            onChange: t19
        });
        $[93] = T0;
        $[94] = t1;
        $[95] = t19;
        $[96] = t2;
        $[97] = t3;
        $[98] = t4;
        $[99] = t5;
        $[100] = t6;
        $[101] = t7;
        $[102] = t20;
    } else t20 = $[102];
    const t21 = getIconColor(scale === zoomLevels[zoomLevels.length - 1]);
    let t22;
    if ($[103] !== t21) {
        t22 = /*#__PURE__*/ jsx(Icon, {
            name: "magnifier_plus_outline",
            size: "20",
            color: t21
        });
        $[103] = t21;
        $[104] = t22;
    } else t22 = $[104];
    let t23;
    if ($[105] !== t22 || $[106] !== zoomIn) {
        t23 = /*#__PURE__*/ jsx(Button, {
            icon: t22,
            onClick: zoomIn
        });
        $[105] = t22;
        $[106] = zoomIn;
        $[107] = t23;
    } else t23 = $[107];
    let t24;
    if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ jsx(Icon, {
            name: "cross_large_outline",
            size: "14"
        });
        $[108] = t24;
    } else t24 = $[108];
    let t25;
    if ($[109] !== onClose) {
        t25 = /*#__PURE__*/ jsx(Button, {
            icon: t24,
            onClick: onClose
        });
        $[109] = onClose;
        $[110] = t25;
    } else t25 = $[110];
    let t26;
    if ($[111] !== T1 || $[112] !== t10 || $[113] !== t11 || $[114] !== t12 || $[115] !== t13 || $[116] !== t14 || $[117] !== t15 || $[118] !== t16 || $[119] !== t20 || $[120] !== t23 || $[121] !== t25 || $[122] !== t8 || $[123] !== t9) {
        t26 = /*#__PURE__*/ jsxs(T1, {
            orientation: t8,
            variant: t9,
            size: t10,
            onClick: t11,
            className: t12,
            children: [
                t13,
                t14,
                t15,
                t16,
                t20,
                t23,
                t25
            ]
        });
        $[111] = T1;
        $[112] = t10;
        $[113] = t11;
        $[114] = t12;
        $[115] = t13;
        $[116] = t14;
        $[117] = t15;
        $[118] = t16;
        $[119] = t20;
        $[120] = t23;
        $[121] = t25;
        $[122] = t8;
        $[123] = t9;
        $[124] = t26;
    } else t26 = $[124];
    let t27;
    if ($[125] !== t17 || $[126] !== t18 || $[127] !== t26) {
        t27 = /*#__PURE__*/ jsx("div", {
            className: t17,
            "data-testid": t18,
            children: t26
        });
        $[125] = t17;
        $[126] = t18;
        $[127] = t26;
        $[128] = t27;
    } else t27 = $[128];
    let t28;
    if ($[129] !== T2 || $[130] !== t27) {
        t28 = /*#__PURE__*/ jsx(T2, {
            children: t27
        });
        $[129] = T2;
        $[130] = t27;
        $[131] = t28;
    } else t28 = $[131];
    return t28;
};
function _temp(zoomLevel) {
    return {
        label: `${100 * zoomLevel}%`,
        value: zoomLevel
    };
}
function _temp2(x) {
    return Math.max(1, x - 1);
}
function _temp3(isDisabled) {
    return isDisabled ? "stroke.secondary" : "bg.light.primary";
}
function _temp4(event_1) {
    return event_1.stopPropagation();
}
function _temp5(option) {
    return option.label;
}
export { PreviewButtons };
